import type { ComponentProps, ReactNode } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { buttonClasses } from "@/components/design/button-classes";
import { itemTypeLabel } from "@/lib/share-item";
import { ShareUrlButton } from "./ShareUrlButton";
import { ShareItemContent } from "./ShareItemContent";

type Item = ComponentProps<typeof ShareItemContent>["item"] & {
  id: string; itemType: string | null; shortDescription?: string | null;
};
export function ShareItemArticle({ item, actions, children }: { item: Item; actions?: ReactNode; children?: ReactNode }) {
  const intl = useIntl();
  return (
            <section data-assistant-anchor="share.item.content">
              <div className="box bg-surface p-5 @sm:p-6">
                <div className="flex items-start justify-between gap-3">
                  <span className="inline-block rounded bg-accent px-1.5 py-0.5 text-smycles-micro uppercase tracking-widest text-ink">
                    {itemTypeLabel(item.itemType)}
                  </span>
                  <div className="-mt-1 flex items-center gap-1.5">
                    <ShareUrlButton
                      path={`/share/discover/${item.id}`}
                      title={intl.formatMessage({ id: "share.itemDetail.share", defaultMessage: "Share" })}
                      className={buttonClasses({ variant: "secondary", size: "compact" })}
                    >
                      <FormattedMessage id="share.itemDetail.shareWithIcon" defaultMessage="↗ Share" />
                    </ShareUrlButton>
                    {actions}
                  </div>
                </div>
                <h1 id="share-item-title" className="smycles-page-title mt-3">{item.name || "–"}</h1>
                {item.shortDescription ? (
                  <p id="share-item-short" className="mt-3 max-w-2xl text-smycles-body leading-relaxed text-ink">{item.shortDescription}</p>
                ) : null}

                <ShareItemContent key={item.id} item={item} />

                {children}
              </div>
            </section>

  );
}
